// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__Bl_Lr","item":"styles_item__L_UqJ"};